import {
    disableSelectedCycle,
    enableSelectedCycle,
    fetchCycleManagementDetails,
    fetchPlannedCycles,
    getAllDRSPlans
} from "../network/InductManagementNetworkAPI";
import {HOUR_MILLISECONDS} from "../../util/Constants";
import {DEFAULT_ALERT} from "../Constants";

export const CycleManagementReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_VIEW":
            fetchCycleManagementDetails(action.data.dispatcher)
            return state
        case "LOAD_DRS_DATA":
            getAllDRSPlans(action.data.dispatcher, action.data.cyclesInfo);
            return state
        case "LOAD_CYCLES":
            fetchPlannedCycles(state.selectedNodeId, action.data.dispatcher)
            return state
        case "ENABLE_CYCLE":
            const enableParams = getEnableCycleParams(state)
            enableSelectedCycle(enableParams, action.data.dispatcher)
            return state
        case "DISABLE_CYCLE":
            const disableParams = getDisableCycleParams(state, action.data.index)
            disableSelectedCycle(disableParams, action.data.dispatcher)
            return state
        case "RECEIVE_DATA":
            return {...state, ...action.data}
        case "SET_VALUE":
            return {...state, ...action.data}
        case "SET_ALERT":
            return {...state, alert: action.data}
        case "CLEAR_ALERT":
            return {...state, alert: DEFAULT_ALERT}
        case "RECEIVE_DATA_DRS":
            let cycleStatus = state.cycleStatus;
            cycleStatus[action.cycleInfo] = action.data;
            return {...state, cycleStatus: cycleStatus}
        default:
            return state
    }
}

const getEnableCycleParams = (state) => {
    return {
        cycleName: state.plannedCycles[state.selectedCycleId].name,
        sortationType: state.plannedCycles[state.selectedCycleId].type,
        cycleId: state.selectedCycleId,
        assignedNode: state.selectedNodeId,
        activeUntilMillis: new Date().getTime() + state.selectedTime * HOUR_MILLISECONDS,
    }
}

const getDisableCycleParams = (state, index) => {
    return {
        cycleName: state.cycleConfig[index].name,
        assignedNode: state.cycleConfig[index].assignedNode,
    }
}



// WEBPACK FOOTER //
// ./src/components/inductmanagementv2/reducer/CycleManagementReducer.js